"use client";

export default function UserMenu({
  username,
  role,
  lineBound = false,
}: {
  username: string;
  role: string;
  lineBound?: boolean;
}) {
  async function logout() {
    await fetch("/api/auth/logout", { method: "POST" });
    window.location.href = "/login";
  }
  return (
    <div className="mt-6 border-t border-gray-100 pt-4">
      <div className="px-2 text-sm text-gray-700">{username}</div>
      <div className="px-2 text-xs text-gray-400">{role}</div>
      <a
        href="/account"
        className="mt-2 flex w-full items-center justify-between rounded-lg border border-gray-200 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-50"
      >
        我的帳號
        <span className={`text-xs ${lineBound ? "text-emerald-600" : "text-gray-300"}`}>
          {lineBound ? "已綁定 LINE" : "未綁定"}
        </span>
      </a>
      <button
        onClick={logout}
        className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-1.5 text-left text-sm text-gray-600 hover:bg-gray-50"
      >
        登出
      </button>
    </div>
  );
}
